import { call, put, takeLatest } from 'redux-saga/effects';
// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as actions from './actions';
import api from 'api/ApiClient';

export function* updateProfile(action, apiClient = api) {
  try {
    const json = yield call(apiClient.updateProfile, action.user);
    const user = json.user;
    yield put(actions.profileUpdateSuccess(user));
    yield put(actions.createSmsSubscriptionRequest());
  } catch (e) {
    yield put(actions.profileUpdateError(e.message));
  }
}

export function* createSmsSubscription(action, apiClient = api) {
  try {
    const json = yield call(apiClient.createSmsSubscription, action);
    yield put(actions.createSmsSubscriptionSuccess(json));
  } catch (e) {
    yield put(actions.createSmsSubscriptionError(e.message));
  }
}

export default function* saga() {
  yield takeLatest(actions.PROFILE_UPDATE_REQUEST, updateProfile);
  yield takeLatest(
    actions.CREATE_SMS_SUBSCRIPTION_REQUEST,
    createSmsSubscription
  );
}
